import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { Chip, chipClasses, styled } from "@mui/material";
import FieldDto from "../../../../Types/Api/DTO/FieldDto";
const CustomDeleteChip = styled(Chip)(() => ({
  [`& .${chipClasses.deleteIcon} : hover`]: {
    color: "red",
  },
}));
export default function DeleteChip({
  label,
  onDelete,
  model,
  active,
}: {
  label: string;
  onDelete: any;
  model: FieldDto;
  active?: boolean;
}) {
  return (
    <CustomDeleteChip
      sx={{ margin: "8px 4px" }}
      label={label}
      //   onClick={handleClick}
      onDelete={() => onDelete(model)}
      color="secondary"
      deleteIcon={<CancelIcon fontSize="medium" color="secondary" />}
      variant="outlined"
    />
  );
}
